import type { TranslationDictionary } from '../types';

export const te: TranslationDictionary = {
  common: {
    appName: 'ApnaBlock',
    save: 'భద్రపరచు',
    cancel: 'రద్దు చేయి',
    delete: 'తొలగించు',
    edit: 'సవరించు',
    create: 'సృష్టించు',
    back: 'వెనుకకు',
    search: 'శోధించండి...',
    filter: 'వడపోత',
    refresh: 'రిఫ్రెష్ చేయి',
    submit: 'సమర్పించు',
    loading: 'లోడ్ అవుతోంది...',
    close: 'మూసివేయి',
    yes: 'అవును',
    no: 'కాదు',
    active: 'క్రియాశీలకం',
    inactive: 'నిష్క్రియం',
    open: 'ఓపెన్',
    pending: 'పెండింగ్‌లో ఉంది',
    approved: 'ఆమోదించబడింది',
    rejected: 'తిరస్కరించబడింది',
    completed: 'పూర్తయింది',
    inProgress: 'పురోగతిలో ఉంది',
    resolved: 'పరిష్కరించబడింది',
    viewDetails: 'వివరాలు చూడండి',
    download: 'డౌన్‌లోడ్ చేయండి',
    print: 'ప్రింట్ చేయండి',
    export: 'ఎగుమతి చేయండి',
    actions: 'చర్యలు',
    status: 'స్థితి',
    date: 'తేదీ',
    total: 'మొత్తం',
    all: 'అన్నీ',
    reset: 'రీసెట్ చేయండి',
    more: 'మరిన్ని',
    select: 'ఎంచుకోండి',
    language: 'భాష',
    selectLanguage: 'భాషను ఎంచుకోండి',
    saveChanges: 'మార్పులను భద్రపరచండి',
    savedSuccessfully: 'విజయవంతంగా భద్రపరచబడింది',
    confirm: 'నిర్ధారించండి',
    home: 'హోమ్',
    favorites: 'ప్రాధాన్యాలు',
    pinned: 'పిన్ చేసినవి',
    tenant: 'సొసైటీ / కమ్యూనిటీ',
    openMenu: 'మెనూ తెరవండి',
    expandMenu: 'మెనూ విస్తరించండి',
    minimizeMenu: 'మెనూ తగ్గించండి',
    lightMode: 'లైట్ మోడ్',
    darkMode: 'డార్క్ మోడ్',
    accountMenu: 'ఖాతా మెనూ',
    commandPalette: 'కమాండ్ ప్యాలెట్',
    searchPages: 'పేజీలను శోధించండి...',
    favorite: 'ఇష్టమైనది',
    pin: 'పిన్ చేయండి',
    calendar: 'క్యాలెండర్',
    inbox: 'ఇన్‌బాక్స్',
    ledger: 'ఖాతా పుస్తకం',
    viewAll: 'అన్నీ చూడండి',
    platformNoSociety: 'ప్లాట్‌ఫారమ్ (ఏ సొసైటీ లేదు)',
    noSociety: 'సొసైటీ లేదు',
    trial: 'ట్రయల్',
    expired: 'గడువు ముగిసింది',
    suspended: 'సస్పెండ్ చేయబడింది',
    emptyTitle: 'ఇక్కడ ఏమీ లేదు',
    emptyDescription: 'వివరాలు అందుబాటులోకి రాగానే ఇక్కడ కనిపిస్తాయి.',
    tryAgain: 'మళ్ళీ ప్రయత్నించండి',
    somethingWentWrong: 'ఏదో తప్పు జరిగింది',
    goBack: 'వెనుకకు వెళ్లండి',
    goToHome: 'హోమ్‌కు వెళ్లండి',
    referenceId: 'రిఫరెన్స్ ఐడీ',
    or: 'లేదా',
  },
  auth: {
    login: 'సైన్ ఇన్ చేయండి',
    logout: 'లాగ్ అవుట్',
    profile: 'ప్రొఫైల్',
    email: 'ఈమెయిల్ చిరునామా',
    password: 'పాస్‌వర్డ్',
    forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా?',
    sendOtp: 'ఓటీపీ పంపండి',
    verifyOtp: 'ఓటీపీని ధృవీకరించండి',
    mobile: 'మొబైల్ నంబర్',
    rememberMe: 'నన్ను గుర్తుంచుకో',
    biometricLogin: 'బయోమెట్రిక్ లాగిన్',
    changePassword: 'పాస్‌వర్డ్ మార్చండి',
    signOut: 'సైన్ అవుట్',
    welcome: 'స్వాగతం',
    signIn: 'సైన్ ఇన్ చేయండి',
    signInSubtitle: 'మీ సొసైటీ వర్క్‌స్పేస్‌ను సురక్షితంగా యాక్సెస్ చేయండి.',
    signingInTo: '{{name}} లోకి సైన్ ఇన్ అవుతున్నారు',
    method: 'పద్ధతి',
    emailTab: 'ఈమెయిల్',
    mobileTab: 'మొబైల్',
    otpTab: 'ఓటీపీ',
    emailLabel: 'ఈమెయిల్ చిరునామా',
    mobileLabel: 'మొబైల్ నంబర్',
    passwordLabel: 'పాస్‌వర్డ్',
    enableBiometricAfterLogin: 'సైన్ ఇన్ తర్వాత బయోమెట్రిక్ లాగిన్‌ను ప్రారంభించండి',
    signInWithBiometrics: 'బయోమెట్రిక్స్‌తో సైన్ ఇన్ చేయండి',
    verifyAndSignIn: 'ధృవీకరించి సైన్ ఇన్ చేయండి',
    changeIdentifier: 'గుర్తింపును మార్చండి',
    enterOtpSentTo: 'మీ {{channel}} కు పంపిన ఓటీపీని నమోదు చేయండి.',
    otpCodeLabel: 'ఓటీపీ కోడ్',
    channelLabel: 'ఛానల్',
    emailChannel: 'ఈమెయిల్',
    smsChannel: 'ఎస్ఎంఎస్',
    forgotPasswordTitle: 'పాస్‌వర్డ్ మర్చిపోయారా',
    forgotPasswordSubtitle: 'మీ ఈమెయిల్ లేదా మొబైల్ నమోదు చేయండి. పాస్‌వర్డ్ రీసెట్ చేయడానికి మేము ఓటీపీ పంపుతాము.',
    emailOrMobile: 'ఈమెయిల్ లేదా మొబైల్ నంబర్',
    backToSignIn: 'తిరిగి సైన్ ఇన్ పేజీకి',
    resetPasswordTitle: 'పాస్‌వర్డ్ రీసెట్ చేయండి',
    resetPasswordSubtitle: 'మీ ఈమెయిల్ లేదా మొబైల్‌కు పంపిన ఓటీపీని నమోదు చేసి, కొత్త పాస్‌వర్డ్ ఎంచుకోండి.',
    newPasswordLabel: 'కొత్త పాస్‌వర్డ్',
    confirmPasswordLabel: 'పాస్‌వర్డ్‌ను నిర్ధారించండి',
    updatePassword: 'పాస్‌వర్డ్‌ను అప్‌డేట్ చేయండి',
    changePasswordTitle: 'పాస్‌వర్డ్ మార్చండి',
    changePasswordSubtitle: 'మీ ఖాతా పాస్‌వర్డ్ మార్చండి. మీరు సైన్ ఇన్ చేసి ఉంటారు.',
    currentPasswordLabel: 'ప్రస్తుత పాస్‌వర్డ్',
    confirmNewPasswordLabel: 'కొత్త పాస్‌వర్డ్ నిర్ధారించండి',
    savePassword: 'పాస్‌వర్డ్ భద్రపరచండి',
    passwordRequirementNotice: 'కనీసం 8 అక్షరాలతో పెద్ద అక్షరం, చిన్న అక్షరం, సంఖ్య మరియు ప్రత్యేక అక్షరం ఉండాలి.',
    bannerTagline: 'ఎంటర్‌ప్రైజ్ సొసైటీ కార్యకలాపాలు — బ్యాంకింగ్, వసూళ్లు, సమావేశాలు మరియు నివాసితులు ఒకే చోట.',
    bannerSubtext: 'కాలనీలు మరియు హౌసింగ్ సొసైటీల కోసం సురక్షిత మల్టీ-టెనెంట్ ప్లాట్‌ఫారమ్.',
    biometricMobileOnly: 'బయోమెట్రిక్ లాగిన్ మొబైల్ యాప్‌లో మాత్రమే అందుబాటులో ఉంది.',
    biometricDesktopInfo: 'బయోమెట్రిక్ లాగిన్ ApnaBlock మొబైల్ యాప్‌లో అందుబాటులో ఉంది.',
    signedInBiometrics: 'బయోమెట్రిక్స్‌తో విజయవంతంగా సైన్ ఇన్ అయ్యారు',
    biometricSessionExpired: 'సెషన్ ముగిసింది లేదా రద్దు చేయబడింది. దయచేసి మీ పాస్‌వర్డ్‌తో సైన్ ఇన్ చేయండి.',
    biometricAuthFailed: 'బయోమెట్రిక్ ప్రమాణీకరణ విఫలమైంది. దయచేసి పాస్‌వర్డ్ ఉపయోగించండి.',
    biometricEnrollSuccess: 'బయోమెట్రిక్ లాగిన్ ప్రారంభించబడింది',
    biometricEnrollCancelled: 'బయోమెట్రిక్ నమోదు రద్దు చేయబడింది. సాధారణ లాగిన్ విజయవంతమైంది.',
    welcomeMarketing: 'మార్కెటింగ్ పార్టనర్ పోర్టల్‌కు స్వాగతం',
    welcomePlatform: 'ప్లాట్‌ఫారమ్ అడ్మినిస్ట్రేషన్‌కు స్వాగతం',
    welcomeBackToast: 'తిరిగి స్వాగతం',
    otpSentSuccess: 'OTP విజయవంతంగా పంపబడింది',
    otpVerifyFailed: 'OTP ధృవీకరణ విఫలమైంది',
    loginFailed: 'లాగిన్ విఫలమైంది',
    biometricAuthReason: 'ApnaBlock లోకి సైన్ ఇన్ చేయడానికి మీ గుర్తింపును ధృవీకరించండి',
    biometricAvailableFor: '{{identifier}} కోసం బయోమెట్రిక్ లాగిన్ అందుబాటులో ఉంది',
    biometricEnrollPrompt: '{{name}} కోసం బయోమెట్రిక్ లాగిన్‌ని ప్రారంభించాలా?',
  },
  nav: {
    dashboard: 'డాష్‌బోర్డ్',
    society: 'సొసైటీ',
    societySettings: 'నా సొసైటీ',
    societyBlocks: 'బ్లాకులు / టవర్లు',
    societyHouses: 'ఇళ్ళు / యూనిట్లు',
    societyResidents: 'నివాసితులు',
    societyStaff: 'సిబ్బంది',
    imports: 'డేటా దిగుమతి',
    finance: 'ఆర్థికం & ఖాతాలు',
    financePayments: 'నా చెల్లింపులు',
    financeCollections: 'వసూళ్లు',
    financeSocietyFund: 'సొసైటీ నిధి',
    financeSpecialCollections: 'ప్రత్యేక వసూళ్లు',
    financeCorpusFund: 'కార్పస్ ఫండ్',
    financeExpenses: 'ఖర్చులు',
    financeExpenseGroups: 'వ్యయ సమూహాలు',
    financeWaterTanker: 'నీటి ట్యాంకర్',
    financeReimbursements: 'రీయింబర్స్‌మెంట్ క్లెయిమ్',
    financeBanking: 'బ్యాంకు ఖాతాలు',
    financeStatements: 'స్టేట్‌మెంట్లు & రసీదులు',
    financeReports: 'ఆర్థిక నివేదికలు',
    financeReconciliation: 'చెల్లింపు సమాధానం',
    security: 'భద్రత & గేట్',
    gatePasses: 'గేట్ పాస్‌లు',
    securityDashboard: 'భద్రతా డాష్‌బోర్డ్',
    securityGates: 'గేట్ నిర్వహణ',
    securityShifts: 'వాచ్‌మెన్ షిఫ్ట్ నివేదికలు',
    securityPolicies: 'భద్రతా విధానాలు',
    securityDeskPortal: 'సెక్యూరిటీ గేట్ డెస్క్',
    visitors: 'సందర్శకుల డెస్క్',
    securityCameras: 'సీసీ కెమెరాలు',
    community: 'కమ్యూనిటీ & సమాచారం',
    notices: 'నోటీసులు',
    communityForum: 'కమ్యూనిటీ ఫోరమ్',
    events: 'కార్యక్రమాలు',
    eventsList: 'కార్యక్రమాలు',
    eventsCalendar: 'ఈవెంట్ క్యాలెండర్',
    invitations: 'ఆహ్వానాలు & స్పందనలు',
    whatsapp: 'వాట్సాప్ లాగ్‌లు',
    notifications: 'నోటిఫికేషన్‌లు',
    operations: 'కార్యకలాపాలు & సహాయం',
    complaints: 'ఫిర్యాదులు',
    serviceRequests: 'సేవా అభ్యర్థనలు',
    serviceDirectory: 'సేవా డైరెక్టరీ',
    amenities: 'సౌకర్యాలు',
    meetings: 'సమావేశాలు',
    documents: 'పత్రాల నిల్వ (Vault)',
    governance: 'పాలన & ఎన్నికలు',
    polls: 'నివాసితుల పోల్స్',
    elections: 'ఎన్నికలు',
    governancePetitions: 'పిటిషన్ దాఖలు చేయండి',
    governanceResignation: 'రాజీనామా సమర్పించండి',
    administration: 'పరిపాలన',
    adminLicense: 'లైసెన్స్',
    adminInvoices: 'సబ్‌స్క్రిప్షన్ బిల్లులు',
    adminRoles: 'పాత్రలు & అనుమతులు',
    adminLetterhead: 'లెటర్‌హెడ్ & బ్రాండింగ్',
    adminIntegrations: 'ఎస్ఎంఎస్ & వాట్సాప్',
    adminAiConfig: 'ఏఐ కాన్ఫిగరేషన్',
    adminNavigation: 'మెనూ అనుకూలీకరణ',
    adminAudit: 'ఆడిట్ లాగ్‌లు',
    documentationGroup: 'సహాయం & డాక్యుమెంటేషన్',
    societySupportDesk: 'సహాయం & మద్దతు',
    docsKnowledgeBase: 'జ్ఞాన కేంద్రం',
    docsRoleMatrix: 'పాత్ర & అనుమతి మాతృక',
    docsQaHub: 'క్యూఏ టెస్ట్ హబ్',
    docsTestExplorer: 'టెస్ట్ కేస్ ఎక్స్‌ప్లోరర్',
    licenseLocked: 'లైసెన్స్',
    platformSocietiesGroup: 'సొసైటీలు & టెనెంట్లు',
    platformSocieties: 'అన్ని సొసైటీలు',
    platformSocietiesNew: 'సొసైటీ నమోదు చేయండి',
    platformSocietyTypes: 'సొసైటీ రకాలు & వర్గీకరణ',
    platformTrials: 'ఉచిత ట్రయల్స్',
    platformSubscriptions: 'సబ్‌స్క్రిప్షన్‌లు',
    platformLicenses: 'సాఫ్ట్‌వేర్ లైసెన్సులు',
    platformPlans: 'సబ్‌స్క్రిప్షన్ ప్రణాళికలు',
    platformInvoices: 'బిల్లింగ్ & ఇన్వాయిస్‌లు',
    platformPricingOverrides: 'ధరల మార్పులు',
    platformCoupons: 'కూపన్లు & రాయితీలు',
    platformPromotionGroup: 'వృద్ధి & ప్రమోషన్',
    platformPromotionDashboard: 'గ్రోత్ డాష్‌బోర్డ్',
    platformPromotionProspects: 'అవకాశాలు & లీడ్స్',
    platformPromotionCampaigns: 'ప్రచారాలు',
    platformPromotionTemplates: 'సందేశ టెంప్లేట్‌లు',
    platformPromotionSenderProfiles: 'పంపినవారి ప్రొఫైల్స్',
    platformPromotionEmail: 'ఈమెయిల్ మార్కెటింగ్',
    platformPromotionWhatsapp: 'వాట్సాప్ బ్రాడ్‌కాస్ట్‌లు',
    platformPromotionSms: 'ఎస్ఎంఎస్ మార్కెటింగ్',
    platformPromotionOther: 'ఇతర ఛానల్స్',
    platformReferrals: 'అనుబంధ & రెఫరల్స్',
    platformMarketing: 'మార్కెటింగ్ సిబ్బంది',
    platformPromotionAnalytics: 'ప్రచార విశ్లేషణలు',
    platformPromotionSettings: 'మార్కెటింగ్ సెట్టింగ్‌లు',
    platformManagementGroup: 'ప్లాట్‌ఫారమ్ & మద్దతు',
    platformWebsite: 'వెబ్‌సైట్ సీఎంఎస్ & బ్రాండింగ్',
    platformSupportTickets: 'సహాయ టిక్కెట్లు డెస్క్',
    platformFeatureRequests: 'ఫీచర్ అభ్యర్థనలు',
    platformFeatures: 'ఫీచర్ ఫ్లాగ్‌లు',
    platformUsers: 'ప్లాట్‌ఫారమ్ నిర్వాహకులు',
    platformCoverageAudit: 'డాక్యుమెంట్ కవరేజ్ ఆడిట్',
    platformReportsGroup: 'విశ్లేషణలు & నివేదికలు',
    platformAnalytics: 'ప్లాట్‌ఫారమ్ విశ్లేషణలు',
    platformSystemGroup: 'సిస్టమ్ & భద్రత',
    platformSystemHealth: 'సిస్టమ్ ఆరోగ్యం',
    platformAuditLogs: 'ఆడిట్ లాగ్‌లు',
    platformNotifications: 'హెచ్చరికలు & నోటిఫికేషన్‌లు',
    platformSettings: 'గ్లోబల్ సెట్టింగ్‌లు',
    platformDataCleanup: 'డేటా క్లీనప్',
    platformGoogleCalendar: 'గూగుల్ క్యాలెండర్ అనుసంధానం',
    platformMaintenance: 'డేటాబేస్ నిర్వహణ',
    directory: 'నివాసితుల డైరెక్టరీ',
    members: 'సభ్యులు',
    houses: 'యూనిట్లు & ఫ్లాట్లు',
    settings: 'సెట్టింగ్‌లు',
    myUnit: 'నా యూనిట్',
    waterTankers: 'నీటి ట్యాంకర్లు',
    patrol: 'గార్డ్ పెట్రోలింగ్',
    cameras: 'లైవ్ సీసీటీవీ',
    marketplace: 'మార్కెట్‌ప్లేస్',
    profile: 'నా ప్రొఫైల్',
    superAdmin: 'ప్లాట్‌ఫారమ్ అడ్మిన్',
    staff: 'సొసైటీ సిబ్బంది',
    helpDesk: 'హెల్ప్‌డెస్క్',
    favorites: 'ప్రాధాన్యాలు',
    pinned: 'పిన్ చేసినవి',
    navGroupHome: 'హోమ్',
    navGroupSociety: 'నా సొసైటీ',
    navGroupMoney: 'చెల్లింపులు & బకాయిలు',
    navGroupSecurity: 'భద్రత & గేట్',
    navGroupCommunity: 'కమ్యూనిటీ',
    navGroupManagement: 'యాజమాన్యం',
    navGroupAdmin: 'నిర్వహణ',
    navGroupHelp: 'సహాయం & పత్రాలు',
    securityNotificationSettings: 'భద్రతా నిబంధనలు',
    securityCcCameras: 'సీసీటీవీ కెమెరాలు',
  },
  mobile: {
    greetingMorning: 'శుభోదయం, {{name}}',
    greetingAfternoon: 'శుభ మధ్యాహ్నం, {{name}}',
    greetingEvening: 'శుభ సాయంత్రం, {{name}}',
    greetingNight: 'శుభరాత్రి, {{name}}',
    greetingGeneric: 'స్వాగతం, {{name}}',
    priorityAttention: 'శ్రద్ధ వహించాల్సినవి',
    priorityAllClear: 'అన్ని బకాయిలు పూర్తయ్యాయి',
    priorityAllClearSub: 'ఎటువంటి పెండింగ్ మెయింటెనెన్స్ లేదు',
    payMaintenance: 'మెయింటెనెన్స్ చెల్లించండి',
    payDues: 'ఇప్పుడే చెల్లించండి',
    viewDues: 'బకాయిలు చూడండి',
    viewReceipt: 'రసీదు చూడండి',
    dueBy: 'చెల్లింపు గడువు {{date}}',
    quickActions: 'త్వరిత చర్యలు',
    actionPay: 'బకాయి చెల్లింపు',
    actionVisitors: 'సందర్శకులు',
    actionRaiseIssue: 'సమస్యను తెలపండి',
    actionNotices: 'నోటీస్ బోర్డు',
    actionBookFacility: 'వసతి బుక్ చేయండి',
    actionEmergency: 'ఎమర్జెన్సీ SOS',
    actionDirectory: 'డైరెక్టరీ',
    actionPolls: 'ఓటింగ్ & పోల్స్',
    actionMeetings: 'సమావేశాలు',
    societyUpdates: 'సొసైటీ అప్‌డేట్స్',
    gateAndVisitors: 'గేట్ & సందర్శకులు',
    upcomingEvents: 'రాబోయే వేడుకలు',
    maintenanceAndReceipts: 'మెయింటెనెన్స్ & రసీదులు',
    pendingApprovals: 'పెండింగ్ ఆమోదాలు',
    collectionsOverview: 'వసూళ్ల వివరాలు',
    pendingReview: 'సమీక్షించాల్సినవి',
    noPendingReviews: 'అన్నీ సమీక్షించబడ్డాయి',
    totalCollected: 'మొత్తం వసూలైనది',
    totalOutstanding: 'మొత్తం బకాయి',
    activeGatePasses: 'యాక్టివ్ గేట్ పాస్‌లు',
    noVisitorsToday: 'ఈ రోజు సందర్శకులు ఎవరూ లేరు',
    noActivePasses: 'యాక్టివ్ పాస్‌లు ఏవీ లేవు',
    preApproveGuest: 'అతిథి ముందస్తు అనుమతి',
    recentReceipts: 'ఇటీవలి రసీదులు',
    noRecentReceipts: 'ఇటీవలి లావాదేవీలు లేవు',
    managementDesk: 'కమిటీ డెస్క్',
    switchRole: 'మార్చుకోండి',
    residentView: 'నివాసి వీక్షణ',
    committeeView: 'కమిటీ వీక్షణ',
    emergencyModalTitle: 'అత్యవసర SOS హెచ్చరిక',
    emergencyModalSubtitle: 'సెక్యూరిటీ గార్డు మరియు సొసైటీ కమిటీకి తక్షణ అత్యవసర సమాచారం పంపండి',
    tapToCall: 'గార్డుకు కాల్ చేయండి',
    tapToWhatsApp: 'వాట్సాప్ కార్యాలయం',
    pullToRefresh: 'రిఫ్రెష్ చేయడానికి క్రిందికి లాగండి',
    refreshing: 'రిఫ్రెష్ అవుతోంది…',
    noMeetingsScheduled: 'ఎటువంటి సమావేశాలు నిర్ణయించబడలేదు',
    noNoticesPublished: 'ప్రకటనలు ఏవీ ప్రచురించబడలేదు',
    noUpcomingEvents: 'రాబోయే వేడుకలు ఏవీ లేవు',
    viewAllNotices: 'అన్ని నోటీసులు చూడండి',
    viewAllEvents: 'అన్ని వేడుకలు చూడండి',
    viewAllComplaints: 'అన్ని సమస్యలు చూడండి',
    sectionDiscover: 'కనుగొనండి',
    sectionEngage: 'పాల్గొనండి',
    sectionPay: 'చెల్లింపు',
    cardResidents: 'నివాసితులు',
    cardResidentsDesc: 'మీ సొసైటీలోని వ్యక్తులను కనుగొనండి',
    cardLocalHelp: 'స్థానిక సహాయం',
    cardLocalHelpDesc: 'రోజువారీ గృహ సహాయకులను కనుగొనండి',
    cardEmergencyContacts: 'అత్యవసర పరిచయాలు',
    cardEmergencyContactsDesc: 'పోలీసులు, అంబులెన్స్ మరియు ముఖ్యమైన నంబర్లు',
    cardHelpDesk: 'సహాయం & ఫిర్యాదులు',
    cardHelpDeskDesc: 'సమస్యను తెలియజేయండి లేదా సహాయం కోరండి',
    cardFacilities: 'సౌకర్యాలు',
    cardFacilitiesDesc: 'సొసైటీ సౌకర్యాలను బుక్ చేయండి',
    cardNotices: 'సొసైటీ నోటీసులు',
    cardNoticesDesc: 'సొసైటీ నుండి ముఖ్యమైన సమాచారం',
    cardCommunity: 'కమ్యూనిటీ',
    cardCommunityDesc: 'పోల్స్, సమావేశాలు మరియు కార్యక్రమాలు',
    cardDocuments: 'పత్రాలు',
    cardDocumentsDesc: 'సొసైటీ మరియు వ్యక్తిగత పత్రాలు',
    cardPaymentsDues: 'చెల్లింపులు & బకాయిలు',
    cardPaymentsDuesDesc: 'బకాయిలు చూసి చెల్లించండి',
    cardUtilities: 'యుటిలిటీలు',
    cardUtilitiesDesc: 'విద్యుత్, నీరు మరియు ఇతర సేవలు',
    actionRequired: 'చర్య అవసరం',
    pendingActionSubtitle: '{{count}} అంశాలు కమిటీ సమీక్ష కోసం వేచి ఉన్నాయి',
    collectionsStatus: 'వసూళ్లు & బకాయిలు',
    uncollectedSocietyDues: '{{count}} పెండింగ్ చెల్లింపులు',
    collectedThisMonth: 'ఈ నెల వసూలైన మొత్తం',
    viewLedger: 'లెడ్జర్ చూడండి',
    committeeActions: 'కమిటీ చర్యలు',
    postNotice: 'నోటీస్ జారీ చేయండి',
    postNoticeDesc: 'సొసైటీకి అధికారిక నోటీస్ పంపండి',
    addExpense: 'ఖర్చును నమోదు చేయండి',
    addExpenseDesc: 'సొసైటీ ఖర్చులను నమోదు చేయండి',
    scheduleMeeting: 'సమావేశం నిర్ణయించండి',
    scheduleMeetingDesc: 'కమిటీ సమావేశం నిర్వహించండి',
    residentDirectory: 'నివాసితుల డైరెక్టరీ',
    residentDirectoryDesc: 'నివాసితులను వెతికి సంప్రదించండి',
    complaintsOverview: 'ఫిర్యాదులు & హెల్ప్‌డెస్క్',
    upcomingMeetingsCount: '{{count}} రాబోయే సమావేశాలు',
    viewMeetingAgenda: 'సమావేశ వివరాలు మరియు ఎజెండా చూడండి',
    resignOfficeTitle: 'రాజీనామా సమర్పించండి',
    resignOfficeNotice: 'సొసైటీ సభ్యులకు అధికారిక రాజీనామాను సమర్పించండి',
    activeSocietyElections: 'క్రియాశీల సొసైటీ ఎన్నికలు',
    votingLiveStatus: 'సభ్యుల కొరకు ఓటింగ్ ప్రారంభమైంది',
    castYourVotePrompt: 'నామినేట్ చేయబడిన కమిటీ అభ్యర్థులకు మీ ఓటు వేయండి',
    recentNotices: 'ఇటీవలి నోటీసులు',
    myComplaints: 'నా ఫిర్యాదులు',
    noActiveComplaints: 'యాక్టివ్ ఫిర్యాదులు లేదా టిక్కెట్లు లేవు',
  },
  profile: {
    profileTitle: 'ప్రొఫైల్ & ప్రాధాన్యతలు',
    profileSubtitle: 'మీ వ్యక్తిగత వివరాలు, సెక్యూరిటీ మరియు భాషను నిర్వహించండి.',
    basicDetails: 'ప్రాథమిక వివరాలు',
    firstName: 'మొదటి పేరు',
    lastName: 'చివరి పేరు',
    email: 'ఈమెయిల్',
    mobile: 'మొబైల్ నంబర్',
    saveDetails: 'వివరాలను భద్రపరచండి',
    userId: 'యూజర్ ఐడీ',
    roles: 'కేటాయించిన పాత్రలు',
    tenant: 'సొసైటీ / కమ్యూనిటీ',
    securityBiometrics: 'సెక్యూరిటీ & బయోమెట్రిక్స్',
    securityBiometricsDesc: 'ఫింగర్‌ప్రింట్ లేదా ఫేస్ ఐడీతో యాప్‌ను త్వరితంగా తెరవండి.',
    biometricLoginEnabled: 'బయోమెట్రిక్ లాగిన్ ఆన్‌లో ఉంది',
    enableBiometricLogin: 'బయోమెట్రిక్ లాగిన్‌ను ప్రారంభించండి',
    notificationPreferences: 'నోటిఫికేషన్ ప్రాధాన్యతలు',
    notificationPreferencesDesc: 'మీరు నోటీసులు మరియు హెచ్చరికలను ఎలా పొందాలో నియంత్రించండి.',
    languagePreferences: 'యాప్ భాష',
    languagePreferencesDesc: 'మీ డిఫాల్ట్ భాషను ఎంచుకోండి. యాప్ ఎల్లప్పుడూ ఈ భాషలోనే తెరుచుకుంటుంది.',
    currentLanguage: 'ప్రస్తుత భాష',
    selectDefaultLanguage: 'డిఫాల్ట్ భాషను ఎంచుకోండి',
    defaultLanguageNotice: 'మీ ప్రాధాన్య భాష భద్రపరచబడింది మరియు ప్రతి లాగిన్‌లో వర్తిస్తుంది.',
    saveLanguage: 'డిఫాల్ట్ భాషగా సెట్ చేయండి',
    languageUpdated: 'భాష ప్రాధాన్యత విజయవంతంగా భద్రపరచబడింది',
  },
  dashboard: {
    welcomeBack: 'పునఃస్వాగతం',
    welcomeBackUser: 'పునఃస్వాగతం, {{name}}',
    societyWorkspace: 'మీ సొసైటీ కార్యక్షేత్రం',
    platformSubtitle: 'వ్యోరా ప్లాట్‌ఫారమ్ · సొసైటీలు మరియు సాఫ్ట్‌వేర్ లైసెన్సులు',
    registerSociety: 'సొసైటీని నమోదు చేయండి',
    registerSocietyHint: 'టెనెంట్ మరియు ప్రెసిడెంట్ లాగిన్ సృష్టించండి',
    allSocieties: 'అన్ని సొసైటీలు',
    allSocietiesHint: 'జాబితా మరియు స్థితి',
    softwareLicenses: 'సాఫ్ట్‌వేర్ లైసెన్సులు',
    softwareLicensesHint: 'సొసైటీని ఎంచుకుని, లైసెన్స్ జారీ లేదా సమీక్షించండి',
    bankBalance: 'బ్యాంకు నిల్వ',
    outstandingDues: 'చెల్లించాల్సిన బకాయిలు',
    residents: 'నివాసితులు',
    openRequests: 'ఓపెన్ అభ్యర్థనలు',
    upcomingMeetings: 'రాబోయే సమావేశాలు',
    platform: 'ప్లాట్‌ఫారమ్',
    societies: 'సొసైటీలు',
    licenses: 'లైసెన్సులు',
    noBankAccounts: 'ఇంకా ఎలాంటి బ్యాంకు ఖాతాలు లేవు',
    allDuesCleared: 'అన్ని బకాయిలు చెల్లించబడ్డాయి',
    noOpenComplaints: 'ఎలాంటి పెండింగ్ ఫిర్యాదులు లేవు',
    noMeetingsScheduled: 'సమావేశాలు ఏవీ నిర్ణయించబడలేదు',
    overdueAndOpen: '{{overdue}} గడువు ముగిసినవి · {{open}} ఓపెన్ బిల్లులు',
    openBillsCount: '{{count}} ఓపెన్ బిల్లులు',
    openBillsCountSingle: '1 పెండింగ్ బిల్లు',
    accountsCountThisMonth: '{{count}} ఖాతాలు · ఈ నెలలో {{amount}} వచ్చింది',
    accountsCountThisMonthSingle: '1 ఖాతా · ఈ నెలలో {{amount}} జమ',
    residentsAndHouses: '{{residents}} నివాసితులు · {{houses}} ఇళ్ళు',
    residentsOnRecord: '{{count}} రికార్డులో ఉన్నారు',
    housesCount: '{{count}} ఇళ్ళు',
    pendingReviewOverdue: '{{pending}} సమీక్షలో ఉన్నాయి · {{overdue}} గడువు దాటినవి',
    pendingReview: '{{count}} సమీక్షలో ఉన్నాయి',
    statManage: 'నిర్వహణ',
    statSubscription: 'చందా',
    collectionsCashflow: 'వసూళ్లు & నగదు ప్రవాహం',
    collected: 'వసూలైనది',
    outstanding: 'బకాయి ఉన్నది',
    thisMonthCashflow: 'ఈ నెల · రాబడి {{credit}} / ఖర్చు {{debit}}',
    cashflow: 'నగదు ప్రవాహం',
    quickActions: 'శీఘ్ర చర్యలు',
    scheduleMeeting: 'సమావేశాన్ని షెడ్యూల్ చేయండి',
    scheduleMeetingHint: 'యజమానులకు మరియు క్యాలెండర్‌కు తెలియజేయండి',
    postNotice: 'నోటీసు పోస్ట్ చేయండి',
    postNoticeHint: 'సొసైటీకి ప్రకటించండి',
    raiseComplaint: 'ఫిర్యాదు నమోదు చేయండి',
    raiseComplaintHint: 'సేవా అభ్యర్థనను లాగ్ చేయండి',
    filePetition: 'పిటిషన్ దాఖలు చేయండి',
    filePetitionHint: 'రాజీనామా లేదా చర్యల కొరకు',
    viewProfile: 'ప్రొఫైల్ చూడండి',
    viewProfileHint: 'ఖాతా & అనుమతులు',
    publicPetitions: 'పబ్లిక్ పిటిషన్‌లు',
    openPetitions: 'ఓపెన్ పిటిషన్‌లు · సభ్యులందరికీ కనిపిస్తాయి',
    openBoard: 'బోర్డు తెరవండి',
    noMeetingsDescription: 'రాబోయే కమిటీ సమావేశాలు ఇక్కడ కనిపిస్తాయి.',
    announcements: 'ప్రకటనలు',
    noAnnouncements: 'ఎలాంటి ప్రకటనలు లేవు',
    noAnnouncementsDesc: 'ప్రచురించిన నోటీసులు ఇక్కడ కనిపిస్తాయి.',
    recentActivity: 'ఇటీవలి కార్యాచరణ',
    noActivity: 'ఇంకా ఎలాంటి కార్యాచరణ లేదు',
    noActivityDesc: 'నోటిఫికేషన్‌లు మరియు అప్‌డేట్‌లు ఇక్కడ కనిపిస్తాయి.',
    recentTransactions: 'ఇటీవలి లావాదేవీలు',
    visitorActivity: 'సందర్శకుల కార్యాచరణ',
    visitorsComingSoon: 'సందర్శకుల మాడ్యూల్ త్వరలో వస్తుంది',
    visitorsComingSoonDesc: 'సందర్శకుల మాడ్యూల్ ప్రారంభించబడినప్పుడు గేట్ లాగ్‌లు ఇక్కడ కనిపిస్తాయి.',
    openVisitors: 'సందర్శకులను తెరవండి',
    recentNotices: 'ఇటీవలి నోటీసులు',
    pendingComplaints: 'పెండింగ్ ఫిర్యాదులు',
    upcomingEvents: 'రాబోయే ఈవెంట్‌లు',
    maintenanceDue: 'మెయింటెనెన్స్ బకాయిలు',
    visitorsToday: 'నేటి సందర్శకులు',
    viewAll: 'అన్నీ చూడండి',
    societyOverview: 'సొసైటీ అవలోకనం',
    activeNotices: 'క్రియాశీల నోటీసులు',
  },
  complaints: {
    title: 'హెల్ప్‌డెస్క్ & ఫిర్యాదులు',
    createComplaint: 'ఫిర్యాదు నమోదు చేయండి',
    category: 'వర్గం',
    priority: 'ప్రాధాన్యత',
    status: 'స్థితి',
    description: 'వివరణ',
    raisedBy: 'నమోదు చేసిన వారు',
    assignedTo: 'కేటాయించబడింది',
    resolve: 'పరిష్కరించినట్లు గుర్తించు',
    myComplaints: 'నా ఫిర్యాదులు',
    allComplaints: 'సొసైటీ ఫిర్యాదులన్నీ',
  },
  visitors: {
    title: 'సందర్శకుల నిర్వహణ',
    logVisitor: 'సందర్శకుడిని ముందుగా అనుమతించు',
    visitorName: 'సందర్శకుడి పేరు',
    phone: 'ఫోన్ నంబర్',
    hostUnit: 'ఫ్లాట్ / యూనిట్',
    purpose: 'సందర్శన ఉద్దేశం',
    vehicleNumber: 'వాహనం నంబర్',
    checkIn: 'చెక్-ఇన్',
    checkOut: 'చెక్-అవుట్',
    expectedVisitors: 'రావలసిన అతిథులు',
    activeVisitors: 'ప్రస్తుతం లోపల ఉన్నవారు',
  },
  finance: {
    title: 'ఆర్థికం & చెల్లింపులు',
    dues: 'చెల్లించాల్సిన బకాయిలు',
    payNow: 'ఇప్పుడే చెల్లించండి',
    transactions: 'లావాదేవీల చరిత్ర',
    invoices: 'మెయింటెనెన్స్ బిల్లులు',
    receipts: 'చెల్లింపు రసీదులు',
    paymentHistory: 'చెల్లింపు చరిత్ర',
    maintenanceFee: 'నెలవారీ నిర్వహణ రుసుము',
    outstandingBalance: 'మొత్తం బకాయి',
    paid: 'చెల్లించబడింది',
    unpaid: 'చెల్లించలేదు',
  },
  notices: {
    title: 'సొసైటీ నోటీసులు',
    createNotice: 'నోటీసు జారీ చేయండి',
    important: 'ముఖ్యమైన నోటీసు',
    publishedOn: 'ప్రచురించిన తేదీ',
    readMore: 'పూర్తి నోటీసు చదవండి',
    attachments: 'జతచేసిన పత్రాలు',
    societyAnnouncements: 'కమ్యూనిటీ ప్రకటనలు',
  },
  amenities: {
    title: 'సొసైటీ సౌకర్యాలు',
    bookAmenity: 'సౌకర్యాన్ని బుక్ చేయండి',
    myBookings: 'నా బుకింగ్‌లు',
    availableSlots: 'అందుబాటులో ఉన్న సమయాలు',
    rules: 'నియమాలు & నిబంధనలు',
  },
  elections: {
    title: 'ఎన్నికలు & పోల్స్',
    activeElections: 'క్రియాశీల ఎన్నికలు',
    castVote: 'మీ ఓటు వేయండి',
    candidates: 'అభ్యర్థులు',
    results: 'ఎన్నికల ఫలితాలు',
  },
  emergency: {
    emergencyAlert: 'అత్యవసర హెచ్చరిక (EMERGENCY)',
    triggerAlert: 'ఎస్ఓఎస్ హెచ్చరిక పంపండి',
    fire: 'అగ్ని ప్రమాదం',
    medical: 'వైద్య అత్యవసరం',
    security: 'భద్రతా ముప్పు',
    panic: 'ప్యానిక్ బటన్',
    sos: 'ఎస్ఓఎస్ బ్రాడ్‌కాస్ట్',
    activeAlert: 'అత్యవసర హెచ్చరిక కొనసాగుతోంది',
  },
  validation: {
    required: 'ఈ ఫీల్డ్ అవసరం.',
    invalidEmail: 'దయచేసి చెల్లుబాటు అయ్యే ఈమెయిల్ చిరునామాను నమోదు చేయండి.',
    invalidMobile: 'దయచేసి చెల్లుబాటు అయ్యే 10-అంకెల మొబైల్ నంబర్‌ను నమోదు చేయండి.',
    passwordTooShort: 'పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి.',
    positiveNumber: 'దయచేసి ధనాత్మక విలువను నమోదు చేయండి.',
  },
  superAdmin: {
    title: 'ప్లాట్‌ఫారమ్ అడ్మినిస్ట్రేషన్',
    dashboard: 'డ్యాష్‌బోర్డ్',
    platformOverview: 'ప్లాట్‌ఫారమ్ అవలోకనం',
    platformOverviewSubtitle: 'నిజ-సమయ మల్టీ-టెనెంట్ సొసైటీ గణాంకాలు, సబ్‌స్క్రిప్షన్ స్థితి, మరియు ప్లాట్‌ఫారమ్ కార్యకలాపాలు',
    totalSocieties: 'మొత్తం సొసైటీలు',
    societiesActiveAndTrial: '{{active}} క్రియాశీలం · {{trial}} ట్రయల్‌లో',
    monthlyRecurring: 'నెలవారీ పునరావృత ఆదాయం (MRR)',
    annualRecurring: 'వార్షిక ARR: {{arr}}',
    activeTrials: 'క్రియాశీల ట్రయల్స్',
    expiringInDays: '30 రోజుల్లో {{count}} ముగుస్తున్నాయి',
    totalPlatformUsers: 'మొత్తం ప్లాట్‌ఫారమ్ వినియోగదారులు',
    acrossAllManagedSocieties: 'నిర్వహించబడుతున్న అన్ని సొసైటీలలో',
    upcomingExpirations: 'రాబోయే ట్రయల్ & లైసెన్స్ గడువు ముగింపు (తదుపరి 30 రోజులు)',
    upcomingExpirationsSubtitle: 'ట్రయల్ పొడిగింపు, పునరుద్ధరణ లేదా మార్పిడి అవసరమైన సొసైటీలు',
    noUpcomingExpirations: 'రాబోయే 30 రోజుల్లో గడువు ముగిసే లైసెన్సులు ఏవీ లేవు.',
    societyName: 'సొసైటీ పేరు',
    plan: 'ప్రణాళిక',
    expiresIn: 'గడువు ముగింపు సమయం',
    manage: 'నిర్వహించండి',
    subscriptionTierShare: 'సబ్‌స్క్రిప్షన్ ప్లాన్ వాటా',
    subscriptionTierShareSubtitle: 'ప్లాన్‌ల వారీగా క్రియాశీల సొసైటీ పంపిణీ',
    noPlanDistribution: 'ప్లాన్ పంపిణీ డేటా అందుబాటులో లేదు',
    daysCount: '{{count}} రోజులు',
    expiredToday: 'ఈరోజే గడువు ముగిసింది',
    freeTrial: 'ఉచిత ట్రయల్',
    analytics: 'ప్లాట్‌ఫారమ్ విశ్లేషణలు',
    societies: 'అన్ని సొసైటీలు',
    societyTypes: 'సొసైటీ రకాలు',
    trials: 'ఉచిత ట్రయల్స్ & ఆన్‌బోర్డింగ్',
    subscriptions: 'సబ్‌స్క్రిప్షన్‌లు',
    licenses: 'సాఫ్ట్‌వేర్ లైసెన్సులు',
    plans: 'సబ్‌స్క్రిప్షన్ ప్రణాళికలు',
    invoices: 'బిల్లింగ్ & ఇన్వాయిస్‌లు',
    pricingOverrides: 'ధరల మార్పులు',
    coupons: 'కూపన్లు & రాయితీలు',
    promotion: 'వృద్ధి & ప్రమోషన్',
    referrals: 'అనుబంధ & రెఫరల్స్',
    marketing: 'మార్కెటింగ్ సిబ్బంది',
    websiteCms: 'వెబ్‌సైట్ CMS & బ్రాండింగ్',
    features: 'ఫీచర్ ఫ్లాగ్‌లు',
    platformUsers: 'ప్లాట్‌ఫారమ్ నిర్వాహకులు',
    systemHealth: 'సిస్టమ్ ఆరోగ్యం',
    auditLogs: 'ఆడిట్ లాగ్‌లు',
    settings: 'గ్లోబల్ సెట్టింగ్‌లు',
    dataCleanup: 'డేటా క్లీనప్',
    maintenance: 'డేటాబేస్ నిర్వహణ',
  },
  tables: {
    noRecords: 'ఎలాంటి రికార్డులు కనుగొనబడలేదు',
    rowsPerPage: 'పేజీకి వరుసలు:',
    pageOf: 'పేజీ {{page}} / {{totalPages}}',
    filterResults: 'ఫలితాలను ఫిల్టర్ చేయండి...',
    showingResults: 'మొత్తం {{count}} ఫలితాలు చూపబడుతున్నాయి',
  },
  dialogs: {
    confirmAction: 'చర్యను నిర్ధారించండి',
    confirmDelete: 'తొలగింపును నిర్ధారించండి',
    areYouSure: 'మీరు ఖచ్చితంగా కొనసాగించాలనుకుంటున్నారా?',
    irreversibleNotice: 'ఈ చర్యను రద్దు చేయలేరు.',
    discardChanges: 'సేవ్ చేయని మార్పులను విస్మరించాలా?',
  },
  feedback: {
    savedSuccess: 'వివరాలు విజయవంతంగా భద్రపరచబడ్డాయి',
    updateSuccess: 'విజయవంతంగా అప్‌డేట్ చేయబడింది',
    errorOccurred: 'లోపం సంభవించింది. దయచేసి మళ్లీ ప్రయత్నించండి.',
    languageChanged: 'భాష తెలుగులోకి మార్చబడింది',
    biometricEnabledSuccess: 'బయోమెట్రిక్ ప్రమాణీకరణ ప్రారంభించబడింది',
    biometricDisabledSuccess: 'బయోమెట్రిక్ ప్రమాణీకరణ నిలిపివేయబడింది',
  },
};
